<template>
  <v-list
    nav
    dense
  >
    <div
      v-for="(item, index) in menu"
      :key="index"
    >
      <div
        v-if="item.key || item.text"
        class="pa-1 mt-2 overline"
      >{{ item.key ? $t(item.key) : item.text }}</div>
      <nav-menu :menu="item.items" />
    </div>
    <div class="d-flex justify-center">
      <img src="../../assets/images/meta_tech_provider.png" alt="Meta Tech Provider" style="height: 49px;width: 130px;margin-top: 31px; margin-right: 18px;">
    </div>
  </v-list>
</template>

<script>
import NavMenu from './NavMenu'

export default {
  components: {
    NavMenu
  },
  props: {
    menu: {
      type: Array,
      default: () => []
    }
  }
}
</script>
